import { createBrowserHistory } from 'history';
import env from '../environment';

export default createBrowserHistory({ basename: env.ROUTER_BASE_NAME });
